import { z } from "zod";
import { timestampSchema } from "../smart-views/schemas";

export const smartCardRecordSchema = z.object({
  id: z.string(),
  associated_space_account_id: z.string(),
  smart_context_id: z.string(),
  smart_view_id: z.string(),
  sort_key: z.string().nullable(),
  added_by_space_account_id: z.string().nullable(),
  derived_kind: z.string().nullable(),
  derived_internal_label: z.string().nullable(),
  originated_from_find_more: z.boolean(),
  value_json: z.unknown().nullable(),
  refreshed_at: timestampSchema,
  created_at: timestampSchema,
  updated_at: timestampSchema,
});

export const smartCardUpsertSchema = z.object({
  id: z.string(),
  associated_space_account_id: z.string(),
  smart_context_id: z.string(),
  smart_view_id: z.string(),
  sort_key: z.string().nullable().optional(),
  added_by_space_account_id: z.string().nullable().optional(),
  derived_kind: z.string().nullable().optional(),
  derived_internal_label: z.string().nullable().optional(),
  originated_from_find_more: z.boolean().optional(),
  value_json: z.unknown().optional(),
  refreshed_at: timestampSchema.optional(),
  created_at: timestampSchema.optional(),
  updated_at: timestampSchema.optional(),
});

export type SmartCardRow = z.infer<typeof smartCardRecordSchema>;
export type SmartCardUpsertInput = z.input<typeof smartCardUpsertSchema>;
